<template>
  <section class="profile-page container py-5 mt-10">
    <!-- Cover & Profile Picture -->
    <div class="position-relative mb-5">
      <img
        src="https://via.placeholder.com/1200x300?text=Cover+Photo"
        class="img-fluid w-100 rounded"
        alt="Cover"
      />
      <div class="profile-img-wrapper position-absolute top-100 start-50 translate-middle">
        <img
          :src="user.avatar || 'https://via.placeholder.com/150'"
          class="rounded-circle border border-white"
          height="150"
          width="150"
          alt="Profile"
        />
      </div>
    </div>

    <!-- Name & Email -->
    <div class="text-center mb-4 mt-5">
      <h3>{{ user.fName }} {{ user.lName }}</h3>
      <p class="text-muted">{{ user.email }}</p>
    </div>

    <!-- Profile Cards -->
    <div class="row gy-4">
      <!-- Personal Info -->
      <div :class="user.accType === 'organizer' ? 'col-md-6' : 'col-12'">
        <div class="card shadow-sm">
          <div class="card-header bg-primary text-white">Personal Information</div>
          <div class="card-body">
            <p><strong>Phone:</strong> {{ user.phone }}</p>
            <p><strong>Country:</strong> {{ user.country }}</p>
            <p><strong>State:</strong> {{ user.state }}</p>
            <p><strong>City:</strong> {{ user.city }}</p>
            <p><strong>Address:</strong> {{ user.address }}</p>
            <p><strong>Account Type:</strong> {{ user.accType }}</p>
          </div>
        </div>
      </div>

      <!-- Business Info (Only if Organizer) -->
      <div v-if="user.accType === 'organizer'" class="col-md-6">
        <div class="card shadow-sm">
          <div class="card-header bg-secondary text-white">Business Information</div>
          <div class="card-body">
            <p><strong>Business Name:</strong> {{ user.bName }}</p>
            <p><strong>Business No:</strong> {{ user.bNo }}</p>
            <p><strong>Business Address:</strong> {{ user.bAddress }}</p>
            <p><strong>Business Email:</strong> {{ user.bMail }}</p>
            <p><strong>Business Contact:</strong> {{ user.bCno }}</p>
            <p><strong>Business Type:</strong> {{ user.bType }}</p>
            <p><strong>Business Status:</strong> {{ user.bStatus }}</p>
          </div>
        </div>
      </div>

      <!-- Subscription Info -->
      <div class="col-12">
        <div class="card shadow-sm">
          <div class="card-header bg-info text-white">Subscription</div>
          <div class="card-body">
            <p><strong>Status:</strong> {{ user.subscription_status }}</p>
            <p><strong>Detail:</strong> {{ user.subscriptionDetail }}</p>
            <p><strong>Last Stripe Fail:</strong> {{ user.stripe_sub_fail_date || 'N/A' }}</p>
            <p><strong>Reason:</strong> {{ user.stripe_sub_fail_reason || 'N/A' }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProfilePage',
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')) || {}
    };
  }
};
</script>

<style scoped>
.profile-img-wrapper {
  margin-top: -75px;
}
.card {
  border-radius: 0.75rem;
}
.card-header {
  font-weight: bold;
}
@media (max-width: 576px) {
  .profile-img-wrapper img {
    height: 100px;
    width: 100px;
  }
}
</style>
